export default __webpack_public_path__ + "static/media/back.8e0365f8.svg";